import React, { FC } from 'react';

import PdfDocument24Icon from '@atlaskit/icon-file-type/glyph/pdf-document/24';
import Generic24Icon from '@atlaskit/icon-file-type/glyph/generic/24';
import Image24Icon from '@atlaskit/icon-file-type/glyph/image/24';
import Audio24Icon from '@atlaskit/icon-file-type/glyph/audio/24';
import Spreadsheet24Icon from '@atlaskit/icon-file-type/glyph/spreadsheet/24';
import Document24Icon from '@atlaskit/icon-file-type/glyph/document/24';
import Video24Icon from '@atlaskit/icon-file-type/glyph/video/24';
import PowerpointPresentation24Icon from '@atlaskit/icon-file-type/glyph/powerpoint-presentation/24';


interface IconeArquivoProps {
  nome: string
}

export const IconeArquivo: FC<IconeArquivoProps> = ({nome}) => {
  const Icone = gerarIconeCorrespondente(nome);

  return <Icone label={`Acessar arquivo "${nome}"`} />
}

function gerarIconeCorrespondente(nome: string) {
  const extensao = obterExtensao(nome);

  const imagens = new Set(["jpg", "jpeg", "png", "bmp", "webp", "gif"]);
  const planilha = new Set([
    // Excel
    "xls", "xlw", "xlt", 
    "xlsx", "xlsm", "xltm", "xlsb",
    "csv",
    // Open Office
    "ods", "ots", "sxc", "stc"
  ]);
  const texto = new Set([
    "doc", "docx",
    "odt", "ott", "oth", "odm",
    "sxw", "stw", "sxg",
  ]);
  const apresentacao = new Set([
    "odp", "odg", "otp",
    "sxi", "sti",
    "ppt", "pps", "pot", "pptx"
  ]);
  const audio = new Set(["mp3"]);
  const video = new Set(["mp4", "mov", "mkv"]);
  const pdf = new Set(["pdf"]);


  if (imagens.has(extensao)) {
    return Image24Icon
  } else if (pdf.has(extensao)) {
    return PdfDocument24Icon
  } else if (planilha.has(extensao)) {
    return Spreadsheet24Icon
  } else if (texto.has(extensao)) {
    return Document24Icon
  } else if (apresentacao.has(extensao)) {
    return PowerpointPresentation24Icon
  } else if (audio.has(extensao)) {
    return Audio24Icon
  } else if (video.has(extensao)) {
    return Video24Icon
  } else {
    return Generic24Icon
  }
}

function obterExtensao(arquivo: string): string {
  const partes = arquivo.split('.')
  const idUltimaParte = partes.length - 1
  const extensao = partes[idUltimaParte] ?? "";

  return extensao.toLowerCase()
}